import { useState } from 'react';

import { formatDateOnly } from '../../utils/date';

import './styles/CollapsibleGroup.css';

// Grupo plegable de receptoras (agenda de dx y worklist de dx). La cabecera resume el lote:
//   (badge dx) · Finca · OPU-nn · TE-nn · [TE / dx1 / dx2] · #receptoras
// Las tres fechas son NOMINALES y las calcula el backend desde la sesión TE (TE + offsets acumulados),
// así que TODAS las receptoras del grupo comparten las mismas → se pintan UNA vez acá, no por fila.
// Al desplegar se renderiza `children` (las receptoras, tal como se ven hoy en cada pantalla).
export default function CollapsibleGroup({
    badge,                 // { label, color }
    farm,
    opu,                   // 'OPU-99'
    te,                     // 'TE-109'
    dates,                 // { te, dx1, dx2 } en 'YYYY-MM-DD'
    count,
    defaultOpen = false,
    selectable = false,    // opt-in: casilla para incluir/excluir el lote (p.ej. al imprimir)
    selected = false,
    onSelect,              // (checked: boolean) => void
    selectTitle,           // tooltip de la casilla
    children,
}) {
    const [open, setOpen] = useState(defaultOpen);
    const d = dates || {};
    const hasDates = d.te || d.dx1 || d.dx2;

    return (
        <section className={`cgroup ${open ? 'cgroup--open' : ''}`}>
            {/* La casilla es HERMANA del botón, no hija: un <input> dentro de un <button> es
                HTML inválido y además cada clic en la casilla plegaría el grupo. */}
            <div className="cgroup__bar">
                {selectable && (
                    <label className="cgroup__pick" title={selectTitle || 'Incluir este lote'}>
                        <input
                            type="checkbox"
                            checked={selected}
                            onChange={(e) => onSelect?.(e.target.checked)}
                        />
                        <span className="cgroup__pick-sr">{selectTitle || 'Incluir este lote'}</span>
                    </label>
                )}

                <button
                    type="button"
                    className="cgroup__head"
                    onClick={() => setOpen((v) => !v)}
                    aria-expanded={open}
                >
                    <span className="cgroup__chevron" aria-hidden="true" />

                    {badge && (
                        <span className="cgroup__badge" style={{ '--badge-color': badge.color }}>{badge.label}</span>
                    )}

                    <span className="cgroup__id">
                        <span className="cgroup__farm">{farm || 'Sin finca'}</span>
                        {opu && <span className="cgroup__ctx">{opu}</span>}
                        {te && <span className="cgroup__ctx">{te}</span>}
                    </span>

                    {hasDates && (
                        <span className="cgroup__dates">
                            {d.te && <span className="cgroup__date" title="Fecha de la transferencia"><b>TE</b> {formatDateOnly(d.te)}</span>}
                            {d.dx1 && <span className="cgroup__date" title="Fecha esperada de dx1 (TE + offset)"><b>dx1</b> {formatDateOnly(d.dx1)}</span>}
                            {d.dx2 && <span className="cgroup__date" title="Fecha esperada de dx2 (TE + offset)"><b>dx2</b> {formatDateOnly(d.dx2)}</span>}
                        </span>
                    )}

                    <span className="cgroup__count" title="Receptoras en el grupo">{count}</span>
                </button>
            </div>

            {open && <div className="cgroup__body">{children}</div>}
        </section>
    );
}
